import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import LoginShell from "./LoginShell";
import { inputClass, linkClass, LoginVariant, submitClass } from "./loginStyles";

const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API,
  headers: { "Content-Type": "application/json" },
});

interface ForgotPasswordProps {
  type: "admin" | "branch";
}

const ForgotPassword = ({ type }: ForgotPasswordProps) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const endpoint =
    type === "admin"
      ? "admin/superemployee/forgot-password"
      : "branch/employee/forgot-password";

  const backLink = type === "admin" ? "/admin-login" : "/login";
  const variant: LoginVariant = type === "admin" ? "admin" : "branch";

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await publicApi.post(endpoint, { email });
      setSent(true);
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoginShell
      variant={variant}
      title="Forgot password"
      subtitle="Enter your email and we'll send a reset link."
    >
      {sent ? (
        <div className="flex flex-col gap-4">
          <p className="m-0 bg-[rgba(6,118,71,0.1)] px-4 py-3.5 text-[0.92rem] font-medium leading-[1.45] text-login-success">
            If an account with that email exists, a password reset link has been
            sent. Check your inbox.
          </p>
          <Link to={backLink} className={`${linkClass(variant)} text-center`}>
            Back to login
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="flex w-full flex-col gap-4">
          <div className="flex w-full flex-col gap-[7px]">
            <label htmlFor="forgot-email" className="login-label">
              Email
            </label>
            <input
              id="forgot-email"
              type="email"
              placeholder="name@company.com"
              className={inputClass(variant)}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className={submitClass(variant)}
          >
            {loading ? "Sending..." : "Send reset link"}
          </button>
          {error ? <span className="login-error">{error}</span> : null}
          <Link to={backLink} className={`${linkClass(variant)} text-center`}>
            Back to login
          </Link>
        </form>
      )}
    </LoginShell>
  );
};

export default ForgotPassword;
